// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyD7xG4qXyL2R-kY149I9CqFbp-Mik7kKf0',
    authDomain: 'lilylearn-lilemo-backend.firebaseapp.com',
    databaseURL: 'https://lilylearn-lilemo-backend.firebaseio.com',
    projectId: 'lilylearn-lilemo-backend',
    storageBucket: 'lilylearn-lilemo-backend.appspot.com',
    messagingSenderId: '205477908048'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
